export const reserveReleaseBounds = (now = new Date()) => {
	const today = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
	const day = 86_400_000;
	return { min: new Date(today + day).toISOString().slice(0, 10), max: new Date(today + 180 * day).toISOString().slice(0, 10) };
};

export const validReserveReleaseDate = (value: string, now = new Date()) => {
	if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
	const date = new Date(`${value}T00:00:00Z`);
	if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== value) return false;
	const { min, max } = reserveReleaseBounds(now);
	return value >= min && value <= max;
};

export const reserveReleaseRequest = (id: number | readonly number[], releaseDate: string, projectId: number, now = new Date()) => {
	const ids = [...new Set(typeof id === "number" ? [id] : id)];
	if (!ids.length || ids.some(value => !Number.isSafeInteger(value) || value <= 0) || !validReserveReleaseDate(releaseDate, now)) throw new Error("Invalid reserve release");
	return { method: "rollings/release", apiVersion: 2 as const, expectedProjectId: projectId, headers: { ignoreBusy: "true" }, data: { ids, release_date: releaseDate } };
};
